import {useAnalyticsFiltersStore} from '../stores/filters';

export const useAnalyticsFilters = () => {
	const selectedCountry = useAnalyticsFiltersStore(s => s.selectedCountry);
	const selectedOffer = useAnalyticsFiltersStore(s => s.selectedOffer);
	const startDate = useAnalyticsFiltersStore(s => s.startDate);
	const endDate = useAnalyticsFiltersStore(s => s.endDate);
	const setFilters = useAnalyticsFiltersStore(s => s.setFilters);
	const resetToDefaults = useAnalyticsFiltersStore(s => s.resetToDefaults);

	return {
		selectedCountry,
		selectedOffer,
		startDate,
		endDate,
		setFilters,
		resetToDefaults,
	};
};
